"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EFinishedStatus;
(function (EFinishedStatus) {
    EFinishedStatus["finished"] = "finished";
    EFinishedStatus["pregame"] = "pregame";
    EFinishedStatus["runningLate"] = "runningLate";
    EFinishedStatus["inProgress"] = "inProgress";
    EFinishedStatus["cancelled"] = "cancelled";
    EFinishedStatus["expired"] = "expired";
})(EFinishedStatus = exports.EFinishedStatus || (exports.EFinishedStatus = {}));
var EFinishedStatusNames;
(function (EFinishedStatusNames) {
    EFinishedStatusNames["finished"] = "Finished";
    EFinishedStatusNames["pregame"] = "Upcoming";
    EFinishedStatusNames["runningLate"] = "Running Late";
    EFinishedStatusNames["inProgress"] = "In progress";
    EFinishedStatusNames["cancelled"] = "Cancelled";
    EFinishedStatusNames["expired"] = "Not Started";
})(EFinishedStatusNames = exports.EFinishedStatusNames || (exports.EFinishedStatusNames = {}));
//# sourceMappingURL=Match.js.map